import * as z from "zod";

export const updateAeoPromptTopic = {
  name: "updateAeoPromptTopic" as const,
  input: z.object({
    topicId: z.bigint(),
    name: z.string().optional(),
    color: z.string().nullable().optional(),
  }),
  output: z.object({ updated: z.boolean() }),
};
